import { Component, OnInit, Inject } from "@angular/core";

import { Platform, MenuController, AlertController } from "@ionic/angular";
import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { ActivatedRoute, Router } from "@angular/router";
import { AndroidPermissions } from "@ionic-native/android-permissions/ngx";
import { Storage } from "@ionic/storage";
import { APIService } from "./services/APIService";
import { AppVersion } from "@ionic-native/app-version/ngx";
import { Market } from "@ionic-native/market/ngx";
import { Push, PushObject, PushOptions } from "@ionic-native/push/ngx";
import { Zoom } from "@ionic-native/zoom/ngx";
import { HttpClient } from "@angular/common/http";
import { DOCUMENT } from "@angular/common";
import { ZoomMtg } from "@zoomus/websdk";


declare let cordova: any;
ZoomMtg.preLoadWasm();
ZoomMtg.prepareJssdk();
@Component({
  selector: "app-root",
  templateUrl: "app.component.html",
  styleUrls: ["app.component.scss"],
})
export class AppComponent implements OnInit {
  signatureEndpoint = "https://apidev.vkonnecthealth.com:3000/joinZoomWeb";
  apiKey = "2O2nlEB_SVemYd4n6jhv_A";
  meetingNumber: any;
  role = 0;
  leaveUrl = window.location.origin;
  userName: any =
    localStorage.getItem("patient_first_name") != null &&
    typeof localStorage.getItem("patient_first_name") != "undefined" &&
    localStorage.getItem("patient_last_name") != null &&
    typeof localStorage.getItem("patient_last_name") != "undefined"
      ? localStorage.getItem("patient_first_name") +
        " " +
        localStorage.getItem("patient_last_name")
      : "Angular";
  userEmail =
    localStorage.getItem("patient_email") != null &&
    typeof localStorage.getItem("patient_email")
      ? localStorage.getItem("patient_email")
      : "";
  passWord = "123456";
  public selectedIndex = 0;
  isLogin: any;
  landing_page: any;
  roomId: any;
  docName: any;
  fcmToken: any;
  drFCM: any;
  docId: any;
  public appPages = [
    {
      title: "Home",
      url: "",
      icon: "/assets/icon/homeGray-svg.svg",
    },
    {
      title: "Privacy Policy",
      url: "privacypolicy",
      icon: "/assets/icon/Privacy policy.svg",
    },
    {
      title: "Terms of use",
      url: "terms",
      icon: "/assets/icon/terms-and-conditions.svg",
    },
    {
      title: "About Us",
      url: "about-us",
      icon: "/assets/icon/about us.svg",
    },
    {
      title: "Support",
      url: "",
      icon: "/assets/icon/support.svg",
    },
  ];

  SDK_KEY = "2OGsIMIGEcvOlazxFaY0L65dMwFWuSIeHXYm";
  SDK_SECRET = "ydnwBXIlauvhxDolVHtD4PodOrbrO5t8v16N";

  constructor(
    private platform: Platform,
    private splashScreen: SplashScreen,
    private statusBar: StatusBar,
    private router: Router,
    private storage: Storage,
    private androidPermissions: AndroidPermissions,
    private menuCtrl: MenuController,
    private apiservice: APIService,
    private alertCtrl: AlertController,
    private appVersion: AppVersion,
    private market: Market,
    private push: Push,
    private zoomService: Zoom,
    public httpClient: HttpClient,
    public route: ActivatedRoute
  ) {
    this.isLogin = 0;
    let params = new URLSearchParams(window.location.search);
    var new_meeting_number = params.get("meeting_id");
    this.docId = params.get("docId");

    if ( new_meeting_number != null || new_meeting_number != "" || typeof new_meeting_number != "undefined"
    ) {
        this.goRoute(new_meeting_number,null);
    }
    if (this.docId) {
        this.goRoute(null,this.docId);
    }

  }


  goRoute(new_meeting_number,docId){
    console.log("new_meeting_number", new_meeting_number);
    console.log("docId", docId);

    if ( new_meeting_number != null) {
      this.meetingNumber = new_meeting_number.toString();
      this.getSignature(this.meetingNumber);
    } else if (docId) {
      this.router.navigate(["/appointment-form"], {
        queryParams: { docId: docId },
      });
    } else {
      this.router.navigate(["tabs/tab1"]);
    }
  }

  getSignature(mn) {
    this.httpClient
      .post(this.signatureEndpoint, {
        meetingNumber: mn,
        role: this.role,
      })
      .toPromise()
      .then((data: any) => {
        if (data.signature) {
          console.log("data.signature", data);
          this.startMeeting(data.signature);
        } else {
          console.log("data 1", data);
        }
      })
      .catch((error) => {
        console.log("error 1", error);
      });
  }

  startMeeting(signature) {
    document.getElementById("zmmtg-root").style.display = "block";

    ZoomMtg.init({
      leaveUrl: this.leaveUrl,
      isSupportAV: true,
      success: (success) => {
        console.log("success 1", success);

        ZoomMtg.join({
          signature: signature,
          meetingNumber: this.meetingNumber,
          userName: this.userName,
          apiKey: this.apiKey,
          userEmail: this.userEmail,
          passWord: this.passWord,
          success: (success) => {
            console.log("success 2", success);
          },
          error: (error) => {
            console.log("error 2", error);
          },
        });
      },
      error: (error) => {
        console.log("error 3", error);
      },
    });
  }
  initializeApp() {
    this.platform.ready().then(() => {
      this.menuCtrl.enable(false);

      this.apiservice.essenseApi().subscribe(
        (response) => {
          console.log(response);
        },
        (error) => {
          console.log(error);
        }
      );

      this.statusBar.backgroundColorByHexString("#000000");

      this.storage.get("fcmToken").then((fcmToken) => {
        this.fcmToken = fcmToken;
        console.log("fcmToken", fcmToken);
      });

      if (this.platform.is("cordova")) {
        this.platform.ready().then(() => {
          this.androidPermissions
            .checkPermission(this.androidPermissions.PERMISSION.CAMERA)
            .then(
              (result) => console.log("Has permission?", result.hasPermission),
              (err) =>
                this.androidPermissions.requestPermission(
                  this.androidPermissions.PERMISSION.CAMERA
                )
            );

          this.androidPermissions
            .checkPermission(this.androidPermissions.PERMISSION.RECORD_AUDIO)
            .then(
              (result) =>
                console.log("Has permission audio?", result.hasPermission),
              (err) =>
                this.androidPermissions.requestPermission(
                  this.androidPermissions.PERMISSION.RECORD_AUDIO
                )
            );

          this.androidPermissions.requestPermissions([
            this.androidPermissions.PERMISSION.CAMERA,
          ]);
          this.androidPermissions.requestPermissions([
            this.androidPermissions.PERMISSION.RECORD_AUDIO,
          ]);
        });
      }

      var me = this;

      // me.apiservice.checkUpdate({
      //   "version": 1016,
      //   "type":"patient",
      //   "device":"android"
      //   }).subscribe(
      //   response => {
      //     console.log("normal response",response.body);
      //   });

      if (this.platform.is("android")) {
        console.log("device is android");

        me.appVersion.getVersionNumber().then(function (version) {
          console.log(version);
          var v = version.split(".").join("");
          console.log("version", v);
          me.apiservice
            .checkUpdate({
              version: Number(v),
              type: "patient",
              device: "android",
            })
            .subscribe(
              (response) => {
                console.log("android response", response.body);
                if (response.body.isUpdate) {
                  me.storage.remove("token");
                  me.storage.set("token", "");
                  me.updateAlert("com.vkonnecthealth.patient");
                } else {
                  me.router.navigate(["tabs/tab1"]);
                }
              },
              (error) => {
                console.log("error", error);
              }
            );
        });
        // this.router.navigate(["tabs/tab1"]);
      }

      if (this.platform.is("ios")) {
        me.appVersion.getVersionNumber().then(function (version) {
          var v = version.split(".").join("");
          console.log("version", v);
          me.apiservice
            .checkUpdate({
              version: Number(v),
              type: "patient",
              device: "ios",
            })
            .subscribe(
              (response) => {
                console.log("ios response", response.body);
                if (response.body.isUpdate) {
                  me.storage.remove("token");
                  me.storage.set("token", "");
                  me.updateAlert("com.vkonnecthealth.patient");
                } else {
                  me.router.navigate(["tabs/tab1"]);
                }
              },
              (error) => {
                console.log("error", error);
              }
            );
        });
      }

      me.router.navigate(["tabs/tab1"]);

      this.splashScreen.hide();

      const options: PushOptions = {
        android: {},
        ios: {
          alert: "true",
          badge: true,
          sound: "false",
        },
        windows: {},
        browser: {
          pushServiceURL: "http://push.api.phonegap.com/v1/push",
        },
      };
      const pushObject: PushObject = this.push.init(options);
      pushObject.on("registration").subscribe((registration: any) => {
        console.log("Device registered", registration);
        this.storage.set("fcmToken", registration.registrationId);
        if (this.fcmToken != registration.registrationId) {
          this.updatefcmToken(registration.registrationId);
        }
      });

      pushObject.on("notification").subscribe((notification: any) => {
        console.log("Received a notification", notification);

        this.landing_page = notification.additionalData.landing_page;
        this.roomId = notification.additionalData.roomId;
        this.docName = notification.additionalData.docName;
        this.drFCM = notification.additionalData.drFCM;
        console.log();

        this.platform.ready().then(() => {
          cordova.plugins.CordovaCall.receiveCall(
            this.docName,
            123,
            (success, err) => {
              if (success) {
                console.log("click receiveCall", success);
              } else {
                console.log("click receiveCall", err);
              }
            }
          );
        });
      });

      pushObject
        .on("error")
        .subscribe((error) => console.error("Error with Push plugin", error));

      this.push
        .createChannel({
          id: "xd",
          description: "Your descrition channel",
          importance: 5,
          // vibration: [2000, 1000, 2000, 1000, 2000],
          // sound: "krishna",
          // visibility: 1,
          // The importance property goes from 1 = Lowest, 2 = Low, 3 = Normal, 4 = High and 5 = Highest.
        })
        .then((data) => console.log("your YourChannel create", data));

      this.platform.ready().then(() => {
        if (this.platform.is("cordova")) {
          cordova.plugins.CordovaCall.on("answer", () => {
            console.log("call accepted");

            this.zoomService
              .initialize(this.SDK_KEY, this.SDK_SECRET)
              .then((success) => {
                console.log("zoom success", success);

                // Join meeting.
                this.zoomService
                  .joinMeeting(this.roomId, "xxxxxx", "patient", options)
                  .then((success: any) => console.log(success))
                  .catch((error: any) => console.log(error));
              })
              .catch((error) => {
                console.log(error);
              });

            // alert("call accepted");
            // me.router.navigate([this.landing_page, this.roomId]);
            cordova.plugins.CordovaCall.endCall((success, err) => {
              if (success) console.log("called ended", success);
              if (err) console.log("err", err);
            });
          });

          cordova.plugins.CordovaCall.on("reject", () => {
            console.log("call rejected");

            this.apiservice.callReject({ drFCM: this.drFCM }).subscribe(
              (response) => {
                console.log("call rejected notified to dr", response);
              },
              (error) => {
                console.log("error in sending call reject notification", error);
              }
            );
          });
        }
      });

      // this.firebase.getToken().then(token => {
      //   console.log("fcmToken jaid", token);
      //   this.storage.set("fcmToken",token);
      // });
    });
  }

  updatefcmToken(fcmToken: any) {
    this.storage.get("tokenData").then((tokenData) => {
      if (!tokenData)
        this.apiservice
          .updatefcmToken({ fcmToken: fcmToken, _id: tokenData })
          .subscribe(
            (response) => {
              console.log("fcm tkoen updated successfully");
            },
            (error) => {
              console.log("error in updating fcm token");
            }
          );
    });
  }

  ngOnInit() {
    const path = window.location.pathname.split("folder/")[1];
    if (path !== undefined) {
      this.selectedIndex = this.appPages.findIndex(
        (page) => page.title.toLowerCase() === path.toLowerCase()
      );
    }

  }

  async updateAlert(packageName: any) {
    const alert1 = await this.alertCtrl.create({
      header: "Vkonnect",
      message: "App update is available",
      backdropDismiss: false,
      buttons: [
        {
          text: "Update",
          role: "yes",
          handler: () => {
            this.market.open(packageName);
          },
        },
      ],
    });
    await alert1.present();
  }
}
